<script lang="ts">
	import { format } from 'svelte-i18n';
	import DashListHolder from '../components/Lists/Dashboards/DashListHolder.svelte';
	import { checkIsEventLogTab, sortByPosition } from '../components/Lists/list-helpers';
	import { capFirstChar } from '../helpers/utilities';
	import { isSubUnit } from 'src/helpers/user_helpers';
	import { devices } from 'src/stores/lists/devices';
	import { scenes } from 'src/stores/lists/scenes';
	import { extended_dashboards } from 'src/stores/features/dashboards';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import DashListHolderNew from 'src/components/Lists/Dashboards/DashListHolderNew.svelte';

	export let params = { type: '', id: '-1' };

	$: list =
		$extended_dashboards?.[params.id]?.sort(sortByPosition).map((el) => {
			if (checkIsEventLogTab(el)) {
				el.text = capFirstChar($format(el.text));
			}

			return el;
		}) || [];

	// Shared-home widgets cache rights at mount; remount when refreshed rights change
	$: dashWidgetRightsKey = isSubUnit()
		? JSON.stringify([
				Object.values($devices).map((d) => d.rights),
				Object.values($scenes).map((s: any) => s._meta?.rights),
			])
		: 'owner';
</script>

{#key dashWidgetRightsKey}
	{#if $showNewLayout}
		<DashListHolderNew id={params.id} {list} />
	{:else}
		<DashListHolder id={params.id} {list} />
	{/if}
{/key}
